import React, { useEffect, useCallback, useState } from 'react';
import { Row, Col, Button, Form, TimePicker } from 'antd';
import moment from 'moment';

const TimeType = ({ question, onEdit, onChange }) => {
  const [selectedTime, setSelectedTime] = useState(null);
  const [form] = Form.useForm();

  const getInitialMoment = (value) => {
    if (!value || value.trim() === '') return null;
    return moment(value, 'HH:mm', true).isValid() ? moment(value, 'HH:mm') : null;
  };

  const setFieldValue = useCallback(() => {
    const initialMoment = getInitialMoment(question.selectedAnswer);
    form.setFieldsValue({ time: initialMoment });
    setSelectedTime(initialMoment);
  }, [question.selectedAnswer, form]);

  const onFinish = (values) => {
    const timeValue = values.time;
    const answerToSave = timeValue ? timeValue.format('HH:mm') : '';
    onChange(question.testId, question.groupId, question.questionId, answerToSave);
    form.resetFields();
  };

  const handleTimeChange = (time) => {
    setSelectedTime(time);
    onEdit(question.questionId, time ? time.format('HH:mm') : '');
    form.setFieldsValue({ time });
  };

  useEffect(() => {
    form.resetFields();
    setFieldValue();
  }, [setFieldValue, form]);

  return (
    <Row justify="center">
      <Form
        onFinish={onFinish}
        form={form}
        initialValues={{ time: getInitialMoment(question.selectedAnswer) }}
        style={{ width: '100%' }}
      >
        <Col md={24}>
          <Row justify="center">
            <Col md={24} className="options-wrapper p-40 mt-40 mb-80">
              <Row justify="center">
                <Col md={24}>
                  <h2
                    className="text-center mt-10 mb-50"
                    dangerouslySetInnerHTML={{ __html: question.questionTitle && question.questionTitle }}
                  />
                </Col>
                <Col md={10}>
                  <Form.Item name="time" className="mb-0">
                    <TimePicker
                      style={{ width: '100%', fontSize: '22px' }}
                      size="large"
                      format="HH:mm"
                      placeholder={question.questionTitle && question.questionTitle}
                      onChange={handleTimeChange}
                      value={selectedTime}
                      minuteStep={1}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>
          {
            question && !question.isChecking &&
            <Row justify="end" className="mb-40">
              <Col md={6}>
                <Button
                  disabled={!selectedTime}
                  className={!selectedTime ? 'button-disabled' : ''}
                  type="primary"
                  size="large"
                  htmlType="submit"
                  block
                >
                  Confirmar cambio
                </Button>
              </Col>
            </Row>
          }
        </Col>
      </Form>
    </Row>
  );
};

export default TimeType;
